import React, { useEffect } from 'react';
import useServiceAuth from 'auth/useServiceAuth';
import Loading from 'components/Loading';

const ServiceAuthRoute = ({ children }) => {
  const { isAuthenticated, isLoading, redirectToServiceauth } =
    useServiceAuth();

  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      // Check if we're currently processing an OAuth callback
      const hasOAuthParams =
        window.location.search.includes('code=') &&
        window.location.search.includes('state=');

      if (hasOAuthParams) {
        console.log(
          '[ServiceAuthRoute] OAuth callback in progress - skipping redirect'
        );
        return;
      }

      // Note: We removed the redirectInProgress check here because
      // redirectToServiceauth() now has timestamp-based stale detection
      // and will automatically clear stale flags older than 30 seconds

      console.log(
        '[ServiceAuthRoute] Not authenticated - initiating redirect to ServiceAuth'
      );
      (async () => {
        await redirectToServiceauth();
      })();
    }
  }, [isAuthenticated, isLoading, redirectToServiceauth]);

  return isAuthenticated ? children : <Loading />;
};

export default ServiceAuthRoute;
